/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {enums} from 'types/enums';

export const TransactionLogFilter = yup.object({
   filterType: yup
      .string()
      .oneOf(enums.filterType.keys)
      .default(enums.filterType.enum.TRANS_FILTER),
   transNames: yup.array().of(yup.string()),
});
export type ITransactionLogFilter = yup.InferType<typeof TransactionLogFilter>;
